// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice___1wPUY","noticeContent":"noticeContent___2nKiF"};